import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { PetitionShareVisualsQuery, PetitionShareVisualsQueryVariables } from './shareVisual.graphql';
import { PetitionShareVisuals } from './shareVisual.graphql';

export type PetitionShareVisualsReturn = Extract<
	NonNullable<PetitionShareVisualsQuery['petition']>['shareVisuals'],
	{ __typename: 'ShareVisualsConnection' }
>['nodes'];

export async function getPetitionShareVisuals(
	{ gql: { fetch }, errorReporter }: UtilityContext,
	slug: string,
): Promise<PetitionShareVisualsReturn> {
	const { data, errors } = await fetch<PetitionShareVisualsQuery, PetitionShareVisualsQueryVariables>({
		query: PetitionShareVisuals,
		variables: {
			slug,
		},
		rejectOnError: false,
	});

	if (errors) return [];

	if (!data || !data.petition || !data.petition.shareVisuals) {
		void errorReporter.report({ error: new Error('No data returned from server'), params: { data } });
		return [];
	}

	if (data.petition.shareVisuals.__typename !== 'ShareVisualsConnection') return [];

	return data.petition.shareVisuals.nodes;
}
